const Loader = () => {
    return <div className="loading"><div className="loader"></div></div>;
}

export default Loader;